import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import ParkDetail from "@/pages/ParkDetail";
import Deals from "@/pages/Deals";
import Regions from "@/pages/Regions";
import RegionGuide from "@/pages/RegionGuide";
import Compare from "@/pages/Compare";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Blog from "@/pages/Blog";
import Landing from "@/pages/Landing";
import EVFriendlyParks from "@/pages/guides/EVFriendlyParks";
import DynamicGuide from "@/pages/guides/DynamicGuide";
import { CompareProvider } from "@/lib/CompareContext";
import useTrackVisits from "@/lib/useTrackVisits";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("parkscanner_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function VisitTracker() {
  useTrackVisits();
  return null;
}

function App() {
  return (
    <CompareProvider>
      <BrowserRouter>
        <VisitTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/park/:slug" element={<ParkDetail />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/regions" element={<Regions />} />
          <Route path="/region/:slug" element={<RegionGuide />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/guides" element={<Blog />} />
          <Route path="/guides/ev-friendly-eco-conscious-caravan-parks-uk-2026" element={<EVFriendlyParks />} />
          <Route path="/guides/:slug" element={<DynamicGuide />} />
          <Route path="/collections/:slug" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </CompareProvider>
  );
}

export default App;
